/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApprovalStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;
